import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicNewsFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M12.5 1.5a2 2 0 012 2v9a2 2 0 01-2 2h-9a2 2 0 01-2-2v-9c0-1.1.9-2 2-2h9zm-7.94 8.6h-.1c-.26.06-.46.33-.46.65 0 .36.25.65.56.65h6.98c.26-.06.46-.33.46-.65 0-.36-.25-.65-.56-.65zm0-2.8h-.1c-.26.06-.46.33-.46.65 0 .36.25.65.56.65h6.98c.26-.06.46-.33.46-.65 0-.36-.25-.65-.56-.65zm.09-2.8h-.1a.65.65 0 00.1 1.3h4.6a.65.65 0 00-.1-1.3z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicNewsFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicNewsFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicNewsFilled svgRef={ref} {...props} />);
export default ForwardRef;
